import React, { useMemo } from "react";
import { useNavigate, useParams } from "react-router-dom";
import { useSelector } from "react-redux";
import PageLastUpdated from "../../components/shared/PageLastUpdated";
import { getDateUpdate } from "../../Utils/utils";
import InnerBannerBreadcrumb from "../../components/shared/breadcrumb/InnerBannerBreadcrumb";
import Loader from "../../components/Loader";
import { useGetHtmlApiQuery } from "../../redux/services/apiHome";

const ExternalPage = () => {
  const navigate = useNavigate();
  const { languageType } = useSelector((state) => state.homeSlice);
  const { id } = useParams();

  const {
    data: externalPageData = {},
    isLoading: externalPageIsLoading,
    isError,
  } = useGetHtmlApiQuery({ url: id, lang: languageType });

  const htmlBody = externalPageData?.body?.[0]?.value;
  const htmlTitle = externalPageData?.title?.[0]?.value;

  const lastUpdatedOn = useMemo(() => {
    return getDateUpdate(externalPageData?.changed?.[0].value);
  }, [externalPageData]);

  if (externalPageIsLoading) {
    return <Loader />;
  }

  if (isError || !externalPageData?.body?.length || !htmlBody) {
    // Navigate to a 404 page or show a fallback UI
    return (
      <>
        <InnerBannerBreadcrumb
          bannerImage="/images/inner_aboutbann.jpg"
          title={"Page Not Found"}
          titleLink="/rti"
          levelTwo={false}
          levelThree={false}
          isActive={"Page Not Found"}
        />

        <div className="inner-container">
          <div className="container">
            <div className="title-sec">
              <h4>Page Not Found</h4>
            </div>
            <p>The requested page is either not created or has been deleted.</p>
            <button className="quick-btn" onClick={() => navigate("/")}>
              Back to Home
            </button>
          </div>
        </div>
      </>
    );
  }

  return (
    <>
      <InnerBannerBreadcrumb
        bannerImage="images/inner_aboutbann.jpg"
        title={htmlTitle}
        titleLink="/rti"
        levelTwo={false}
        titleTwo={"rtiObjtitle2"}
        levelThree={false}
        isActive={htmlTitle}
      />

      <div className="inner-container">
        <div className="container">
          <PageLastUpdated lastUpdatedOn={lastUpdatedOn} />
          <section className="ourCompany">
            <div dangerouslySetInnerHTML={{ __html: htmlBody }}></div>
          </section>
        </div>
      </div>
    </>
  );
};

export default ExternalPage;
